import { AbstractControl } from '@angular/forms'

export function nameIsValid(control: AbstractControl): { [key: string]: boolean } | null {
	const regex = new RegExp(/^([A-zÁ-ú]){2,}\s+([A-zÁ-ú])+/)
	if (!regex.test(control.value)) {
		return { invalidName: true }
	}
	return null
}
